import React, { memo } from 'react'
import CardItem from './cardItem'

const CardList = ({ list, itemClickHandler }) => {
  return (
    <div className="flex gap-6 flex-wrap">
      {list.map((v) => (
        <CardItem key={v.id} data={v} itemClickHandler={itemClickHandler} />
      ))}
    </div>
  )
}

export default memo(CardList)
